import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';
import { SxProps } from '@mui/system';

// project-imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from 'config';
import { useBuyNowLink } from 'hooks/buyNowLink';
import useAuth from 'hooks/useAuth';

interface Props {
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ isIcon, sx, to }: Props) {
  const { isLoggedIn } = useAuth();
  const { getQueryParams } = useBuyNowLink();
  const logoTarget = to ?? (isLoggedIn ? APP_DEFAULT_PATH + getQueryParams : undefined);

  return (
    <ButtonBase disableRipple aria-label="Go to home page" sx={sx} {...(logoTarget && { component: Link, to: logoTarget })}>
      {isIcon ? <LogoIcon /> : <Logo />}
    </ButtonBase>
  );
}
